module.exports = __webpack_public_path__ + "static/media/P3trans2.9ac815d9.png";